import { createSlice } from "@reduxjs/toolkit";

const templateSlice = createSlice({
    name: "template", // แก้ชื่อ slice เป็น "template" จาก "tamplate"
    initialState: {
        isLoading: false,
        templateData: {},
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setTemplateData(state, action) {
            state.templateData = action.payload;
        },
    },
});


export const { setIsLoading, setTemplateData } = templateSlice.actions;
export default templateSlice.reducer;
